import { render, staticRenderFns } from "./EditNumber.vue?vue&type=template&id=6224652c&"
import script from "./EditNumber.vue?vue&type=script&lang=ts&"
export * from "./EditNumber.vue?vue&type=script&lang=ts&"
import style0 from "./EditNumber.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports